<template>
  <div>
    <el-card style="margin-bottom: 20px">
      <el-row>
        <el-col>
          <el-date-picker
            v-model="starttime"
            type="datetimerange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            @change="onChangeTime"
          >
          </el-date-picker>

          <el-button type="goon" style="margin-left: 10px" @click="onSearch"
            >查询</el-button
          >
          <el-button
            v-if="!isData"
            type="goon"
            style="margin-left: 10px"
            @click="ExportGetBookkeepingdietInfo"
            >导出</el-button
          >
        </el-col>
      </el-row>
    </el-card>
    <template v-if="!isData">
      <three-report :BookInfo="BookInfo"></three-report>
    </template>
    <template v-if="isData">
      <el-card>
        <el-empty :description="isDataText"></el-empty>
      </el-card>
    </template>
  </div>
</template>
<script>
import {
  GetBookkeepingdietInfo,
  ExportGetBookkeepingdietInfo,
} from "../../../api/api";
import threeReport from "../../../components/Report/Three.vue";

export default {
  components: {
    threeReport,
  },
  data() {
    return {
      options: [],
      value: "",
      tableData: [],
      PageSize: 10,
      PageIndex: 1,
      total: 0,
      starttime: [],
      userInfo: {},
      UpdateString: "",
      BookInfo: {},
      isData: false,
      isDataText: "暂无数据",
    };
  },
  async created() {
    this.userInfo = JSON.parse(window.localStorage.user);
    let Time = localStorage.getItem("Time");

    if (Time) {
      this.starttime = JSON.parse(localStorage.getItem("Time"));
    } else {
      await this.getNowTime();
    }
    await this.GetBookkeepingdietInfo();
  },
  methods: {
    async ExportGetBookkeepingdietInfo() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let res = await ExportGetBookkeepingdietInfo({
        StartDate: this.starttime[0],
        EndDate: this.starttime[1],
      });
      if (res.data.success) {
        loading.close();
        window.open(res.data.response);
      }
    },
    onChangeTime(e) {
      localStorage.setItem("Time", JSON.stringify(e));

      console.log(e);
    },
    async GetBookkeepingdietInfo() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let res = await GetBookkeepingdietInfo({
        StartDate: this.starttime[0],
        EndDate: this.starttime[1],
      });
      loading.close();
      if (res.data.success) {
        this.isData = false;
        this.BookInfo = res.data.response;
      } else {
        this.isData = true;
        this.isDataText = res.data.msg;
      }
    },
    onEmpty() {},
    // 导出
    async onClickOpen() {
      switch (this.currentIndex) {
        // case 0:
        //   window.open(
        //     `http://apiv3.mushroomisland.cn/api/mgd/He_FoodReportTableControlle/Export_GetPeopleDayPeport?SchoolId=${this.userInfo.SchoolId}&StartDate=${this.starttime[0]}&EndDate=${this.starttime[1]}`,
        //     "_brank"
        //   );
        //   break;
        case 0:
          window.open(
            `http://apiv3.mushroomisland.cn/api/mgd/He_FoodReportTableControlle/Export_GetNutrientSource?SchoolId=${this.userInfo.SchoolId}&StartDate=${this.starttime[0]}&EndDate=${this.starttime[1]}`,
            "_brank"
          );
          break;
        case 1:
          window.open(
            `http://apiv3.mushroomisland.cn/api/mgd/He_FoodReportTableControlle/Export_GetFoodEvaluate?SchoolId=${this.userInfo.SchoolId}&StartDate=${this.starttime[0]}&EndDate=${this.starttime[1]}`,
            "_brank"
          );
          break;
      }
    },

    // 进入报告
    onOpenReport() {
      this.$router.push({
        path: "/Report",
        query: {
          StartDate: this.starttime[0],
          EndDate: this.starttime[1],
        },
      });
    },
    onSearch() {
      this.GetBookkeepingdietInfo();
    },
    async getNowTime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var day = now.getDate(); //得到天
      if (day < 10) {
        day = "0" + day;
      }
      month = month + 1;
      month = month.toString().padStart(2, "0");
      var defaultDate = `${year}-${month}`;
      this.value1 = defaultDate;
      this.value2 = defaultDate;
      this.value3 = defaultDate;
      this.value4 = defaultDate;
      this.value6 = defaultDate;

      this.starttime.push(`${year}-${month}-01`);
      this.starttime.push(`${year}-${month}-${day}`);
    },
    // 检查是否为空
    isNull(value) {
      if (value) {
        return false;
      }
      return true;
    },
  },
};
</script>
<style lang="less" scoped>
.el-button--goon {
  color: #fff;
  background-color: #5474e6;
  border-color: #5474e6;
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
}

.tui-box {
  width: 3.125rem;
  height: 30px;
  background: #e5ebff;
  border-radius: 15px;
  border: 1px solid #cdcdcd;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;

  .tui-box-item {
    padding: 0 10px;
    height: 100%;
    cursor: pointer;
    border-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
  }

  .tui-box-active {
    background: #5474e6 !important;
    color: #fff !important;
  }
}

.tui-tableTitle {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #666666;
  padding: 20px 0;
}
</style>